import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import StudentPortal from './StudentPortal'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider expectedRole="student">
        <StudentPortal />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
